import { Component, Input } from '@angular/core';
import { CurrencyWalletService } from 'src/app/layouts/currency-wallet/currency-wallet.service';
import { CointxHistoryInterface, CurrencytxHistoryInterface } from 'src/app/shared/interfaces/history.interface';

@Component({
  selector: 'app-ongoing-unit',
  templateUrl: './ongoing-unit.component.html',
  styleUrl: './ongoing-unit.component.scss',
})
export class OngoingUnitComponent {
  constructor(protected currencyWalletService: CurrencyWalletService) {}

  @Input() item!: CurrencytxHistoryInterface | CointxHistoryInterface;
}
